import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'formatImageUrl'
})
export class FormatImageUrlPipe implements PipeTransform {
  constructor(protected sanitizer: DomSanitizer) {}

  transform(value: string, ...args: unknown[]): unknown {
    var result: any = value;
    if (result) result = result.replaceAll('\\', '/');
    return result;
  }

}
